import { useEffect, useState } from "react"
import { Link , useParams } from "react-router-dom"
import DataSelect from "../../Components/DataSelect"
import { useEditThemeMutation, useGetEditQuery } from "../../Redux/Apis/panelApi"
import Loading from "../../Layouts/Loading"
import Error from "../../Layouts/Error"
import { useDispatch } from "react-redux"
import { selectSection, setSection } from "../../Redux/Slices/sectionSlice"
import { useSelector } from "react-redux"
import { Media } from '../../Components/Media'

export default function EditTheme(){
    let { pageId } = useParams();
    let [resetKey,setKey] = useState(0)
    const dispatch = useDispatch()
    const formState = useSelector(selectSection)
    const [errorMsg, setErrorMsg] = useState<any>(false)
    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error,
    } = useGetEditQuery(pageId)
    const [edit,{isLoading: isLoadingEdit}] = useEditThemeMutation()

    useEffect(() => {
      return () => {
        document.addEventListener('hide.bs.collapse', (event) => {
            const btn = document.getElementById('submitButton') as HTMLElement
            if (btn) {
                btn.click();
            }
        })
      }
    }, [])
    
    const resetForm = (key: string,value:any,page_id:number) => {
        dispatch(setSection({
            page_id,
            key: key,
            name: value.name,
            caption: value.caption,
            visible: value.visible,
            order: value.order,
            data: value.data,
        }))
        const del = document.querySelectorAll('.newAdded')
        if (del){
            del.forEach(item => {
                item.remove();
            })
        }
    }

    const handleChange = ({ target: { name, value , checked}} : React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | any >) =>
        dispatch(setSection((name === "visible" ? { ...formState , [name]: checked ? true : false } : { ...formState,[name]: value } )))

    const onSubmit = async (e : React.FormEvent) => {
        e.preventDefault()
        try {
            await edit(formState)
            setErrorMsg(false) 
            setKey(resetKey + 1)
            const del = document.querySelectorAll('.newAdded')
            if (del){
                del.forEach(item => {
                    item.remove();
                })
            }
        } catch (err:any){
            console.log(err);
            const message = !err.data ? '' : Array.isArray(err.data.message) ? err.data.message[0] : err.data.message
            setErrorMsg(message)                                     
        }
    }
    
    if(isLoading)
        return <Loading/>

    else if(isError)
        return <Error error={error}/>

    else if(isSuccess) {
      return (
        <div className="container-fluid">
            <Media />
            <div className="row mt-1 p-0">
                <div className="col-lg-3 col-md-4 m-0">
                    <div className="card">
                        <div className="card-header">
                            <Link to="/edit-pages" className="btn btn-secondary float-start"><span className="zmdi zmdi-chevron-right"></span> </Link>
                            <h5 className="float-start mt-2 ms-2">
                                 {`ویرایش ${data.general.name}`}
                            </h5>
                            <button id="submitButton" className="btn btn-success float-end" type="submit" form='editForm' disabled={isLoadingEdit}>ذخیره</button>
                        </div>

                        <div className="card-body">
                            <div className="accordion accordion-flush" id="editAccordion">
                                { Object.entries(data).map(([key, value]:any, index) => 
                                    key !== 'general' &&
                                    <div className="accordion-item" key={index}>
                                        <h2 className="accordion-header" id={`flush-heading${index}`}>
                                            <button onClick={() => resetForm(key,value,data.general.page_id)} className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#flush-collapse${index}`} aria-expanded="false" aria-controls="flush-collapseOne">
                                                {value.name}
                                            </button>
                                        </h2>
                                        <div id={`flush-collapse${index}`} className="accordion-collapse collapse disable" aria-labelledby={`flush-heading${index}`} data-bs-parent="#editAccordion">
                                            <div className="accordion-body">
                                            {errorMsg && <div className="alert alert-danger" role="alert">
                                                {errorMsg}
                                            </div>}
                                                <form onSubmit={onSubmit} id='editForm'>
                                                    {value.visible !== undefined && <div className="form-check form-switch mb-3">
                                                        <input className="form-check-input" onChange={handleChange} name="visible" type="checkbox" role="switch" id={`visibleCheck${index}`} defaultChecked={value.visible} />
                                                        <label className="form-check-label" htmlFor={`visibleCheck${index}`}>فعال سازی</label>
                                                    </div>}
                                                    {value.changeable && <div className="form-floating mb-3">
                                                        <input type="text" className="form-control" onChange={handleChange} name="name" id={`textInput${index}`} defaultValue={value.name} />
                                                        <label htmlFor={`textInput${index}`}>نام بخش</label>
                                                    </div>}
                                                    {value.caption && <div className="form-floating mb-3">
                                                        <textarea className="form-control" id={`textEreaInput${index}`} name="caption" onChange={handleChange} defaultValue={value.caption} />
                                                        <label htmlFor={`textEreaInput${index}`}>توضیحات</label>
                                                    </div>}
                                                    <DataSelect node={value.data} url={data.general.url}/>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>  
                    
                </div>
                <div className="col-lg-9 col-md-8 m-0 d-none d-sm-block">
                    <iframe id="myIframe" title="SITE" key={resetKey} src={data.general.url + data.general.page_key} className="d-block" style={{overflow:"hidden",height:"100vh",width:"100%"}}></iframe>
                </div>
            </div>
        </div>
    )
    }

    else return <></>
}